<template>
    <!-- <v-card color="grey lighten-2"> -->
    <!-- Container para Información: -->
    <v-container>
        <v-layout row justify-space-around>
            <!-- Flex para la ventana: **************************************************************** -->
            <v-flex xs12 sm11 elevation-6>
                <div class="sub-window">
                    <v-container pa-1 grid-list-md>
                        <!-- Encabezado con el título de la subventana y el botón para cerrarla: -->
                        <v-layout row>
                            <v-flex xs10 class="text-left">
                                <div
                                    class="text-left display-1 font-weight-bold teal--text text--lighten-2"
                                >{{ $t('title')}}</div>
                            </v-flex>
                            <v-flex xs2 class="text-right">
                                <v-tooltip bottom>
                                    <template v-slot:activator="{ on }">
                                        <v-btn text @click="onClose" v-on="on">
                                            <v-icon color="teal lighten-1">mdi-close</v-icon>
                                        </v-btn>
                                    </template>
                                    <span>{{ $t('btn-cerrar')}}</span>
                                </v-tooltip>
                            </v-flex>
                        </v-layout>
                        <v-divider class="teal lighten-1"></v-divider>
                        <v-layout row wrap>
                            <v-flex xs12>
                                <v-card class="mx-auto transparent" width="100%" elevation="0">
                                    <v-card-text class="teal--text text--lighten-5 text-sm-left">
                                        {{ $t('p1')}}
                                    </v-card-text>

                                    <v-card-text>
                                        <v-container>
                                            <v-layout row>
                                                <v-flex xs12 md4>
                                                    <v-card
                                                        max-width="100%"
                                                        class="mx-auto"
                                                        @click="onRetroalimentacion360"
                                                    >
                                                        <v-img
                                                            src="@/assets/recursos/ejecutivo1.png"
                                                            class="align-end"
                                                            width="100%"
                                                            gradient="to bottom, rgba(0,0,0,0), rgba(0,0,0,1)"
                                                        >
                                                            <v-container>
                                                                <v-layout row justify-center>
                                                                    <v-flex
                                                                        xs12
                                                                        class="text-center font-weight-bold subtitle-1 teal--text text--lighten-2"
                                                                    >{{ $t('feedback360')}}</v-flex>
                                                                </v-layout>
                                                            </v-container>
                                                        </v-img>
                                                    </v-card>
                                                </v-flex>

                                                <v-flex xs12 md4>
                                                    <v-card
                                                        max-width="100%"
                                                        class="mx-auto"
                                                        @click="onEquiposDeTrabajo"
                                                    >
                                                        <v-img
                                                            src="@/assets/recursos/reporteEquipo1.png"
                                                            class="align-end"
                                                            width="100%"
                                                            gradient="to bottom, rgba(0,0,0,0), rgba(0,0,0,1)"
                                                        >
                                                            <v-container>
                                                                <v-layout row justify-center>
                                                                    <v-flex
                                                                        xs12
                                                                        class="text-center font-weight-bold subtitle-1 teal--text text--lighten-2"
                                                                    >{{ $t('workTeams')}}</v-flex>
                                                                </v-layout>
                                                            </v-container>
                                                        </v-img>
                                                    </v-card>
                                                </v-flex>
                                                <v-flex xs12 md4>
                                                    <v-card
                                                        max-width="100%"
                                                        class="mx-auto"
                                                        @click="onInteligenciaEmocional"
                                                    >
                                                        <v-img
                                                            src="@/assets/recursos/reporteIE1.png"
                                                            class="align-end"
                                                            width="100%"
                                                            gradient="to bottom, rgba(0,0,0,0), rgba(0,0,0,1)"
                                                        >
                                                            <v-container>
                                                                <v-layout row justify-center>
                                                                    <v-flex
                                                                        xs12
                                                                        class="text-center font-weight-bold subtitle-1 teal--text text--lighten-2"
                                                                    >{{ $t('emotionalIntelligence')}}</v-flex>
                                                                </v-layout>
                                                            </v-container>
                                                        </v-img>
                                                    </v-card>
                                                </v-flex>
                                            </v-layout>
                                        </v-container>
                                    </v-card-text>
                                    <v-card-text class="teal--text text--lighten-5 text-sm-left">
                                        {{ $t('p2')}}
                                    </v-card-text>

                                    <v-card-text>
                                        <v-container>
                                            <v-layout row>
                                                <v-flex xs12 md6>
                                                    <v-list dark dense two-line>
                                                        <v-list-item @click="onDoc1">
                                                            <v-list-item-avatar>
                                                                <v-icon
                                                                    color="red"
                                                                >mdi-file-pdf-box</v-icon>
                                                            </v-list-item-avatar>
                                                            <v-list-item-content>
                                                                <v-list-item-title>13 Common Mistakes Using 360-Degree Feedback</v-list-item-title>
                                                                <v-list-item-subtitle>Optima 360</v-list-item-subtitle>
                                                            </v-list-item-content>
                                                        </v-list-item>
                                                        <v-list-item @click="onDoc2">
                                                            <v-list-item-avatar>
                                                                <v-icon
                                                                    color="red"
                                                                >mdi-file-pdf-box</v-icon>
                                                            </v-list-item-avatar>
                                                            <v-list-item-content>
                                                                <v-list-item-title>360-Degree Feedback - Best Practices to Ensure Impact</v-list-item-title>
                                                                <v-list-item-subtitle>Creative Leadership</v-list-item-subtitle>
                                                            </v-list-item-content>
                                                        </v-list-item>
                                                        <v-list-item @click="onDoc3">
                                                            <v-list-item-avatar>
                                                                <v-icon
                                                                    color="red"
                                                                >mdi-file-pdf-box</v-icon>
                                                            </v-list-item-avatar>
                                                            <v-list-item-content>
                                                                <v-list-item-title>360-Degree Feedback - Best Practice Guidelines</v-list-item-title>
                                                                <v-list-item-subtitle>360-Degree Feedback</v-list-item-subtitle>
                                                            </v-list-item-content>
                                                        </v-list-item>
                                                        <v-list-item @click="onDoc4">
                                                            <v-list-item-avatar>
                                                                <v-icon
                                                                    color="red"
                                                                >mdi-file-pdf-box</v-icon>
                                                            </v-list-item-avatar>
                                                            <v-list-item-content>
                                                                <v-list-item-title>Best practices in utilizing 360 degree fedback</v-list-item-title>
                                                                <v-list-item-subtitle>Envisia Learning</v-list-item-subtitle>
                                                            </v-list-item-content>
                                                        </v-list-item>
                                                    </v-list>
                                                </v-flex>
                                                <v-flex xs12 md6>
                                                    <v-list dark dense two-line>
                                                        <v-list-item @click="onDoc5">
                                                            <v-list-item-avatar>
                                                                <v-icon
                                                                    color="red"
                                                                >mdi-file-pdf-box</v-icon>
                                                            </v-list-item-avatar>
                                                            <v-list-item-content>
                                                                <v-list-item-title>Performance consulting versus performance coaching</v-list-item-title>
                                                                <v-list-item-subtitle>Constructive Choices</v-list-item-subtitle>
                                                            </v-list-item-content>
                                                        </v-list-item>
                                                        <v-list-item @click="onDoc6">
                                                            <v-list-item-avatar>
                                                                <v-icon
                                                                    color="red"
                                                                >mdi-file-pdf-box</v-icon>
                                                            </v-list-item-avatar>
                                                            <v-list-item-content>
                                                                <v-list-item-title>Coaching ejecutivo. Del discurso a la práctica</v-list-item-title>
                                                                <v-list-item-subtitle>Coaching Magazine</v-list-item-subtitle>
                                                            </v-list-item-content>
                                                        </v-list-item>
                                                        <v-list-item @click="onDoc7">
                                                            <v-list-item-avatar>
                                                                <v-icon
                                                                    color="red"
                                                                >mdi-file-pdf-box</v-icon>
                                                            </v-list-item-avatar>
                                                            <v-list-item-content>
                                                                <v-list-item-title>La evaluación de 360 grados. ¿Moda o Sistema efectivo?</v-list-item-title>
                                                                <v-list-item-subtitle>Qartil</v-list-item-subtitle>
                                                            </v-list-item-content>
                                                        </v-list-item>
                                                    </v-list>
                                                </v-flex>
                                            </v-layout>
                                        </v-container>
                                    </v-card-text>

                                </v-card>
                            </v-flex>
                        </v-layout>
                    </v-container>
                </div>
            </v-flex>
        </v-layout>
    </v-container>
    <!-- </v-card> -->
    <!-- Fin container para toda la página ********************************************* -->
</template>
<script>
import { mapGetters } from 'vuex';

export default {
    name: 'Recursos',
    data() {
        return {
        };
    },
    created()
    {
    },
    methods:
    {
        onRetroalimentacion360()
        {
            window.open('https://www.retroalimentame.com.mx/reportes/retro360.pdf');
        },
        onEquiposDeTrabajo()
        {
            window.open('https://www.retroalimentame.com.mx/reportes/equipos.pdf');
        },
        onInteligenciaEmocional()
        {
            window.open('https://www.retroalimentame.com.mx/reportes/ie.pdf');
        },
        onDoc1()
        {
            window.open('https://www.retroalimentame.com.mx/informacion/downloads/13CommonMistakes.pdf');
        },
        onDoc2()
        {
            window.open('https://www.retroalimentame.com.mx/informacion/downloads/360bestpractices.pdf');
        },
        onDoc3()
        {
            window.open('https://www.retroalimentame.com.mx/informacion/downloads/360bestpractices2.pdf');
        },
        onDoc4()
        {
            window.open('https://www.retroalimentame.com.mx/informacion/downloads/360bestpractices3.pdf');
        },
        onDoc5()
        {
            window.open('https://www.retroalimentame.com.mx/informacion/downloads/coachingforperformanceArticulo1.pdf');
        },
        onDoc6()
        {
            window.open('https://www.retroalimentame.com.mx/informacion/downloads/CoachingEjecutivoDelDiscursoalaPractica.pdf');
        },
        onDoc7()
        {
            window.open('https://www.retroalimentame.com.mx/informacion/downloads/evaluacion360enespanol.pdf');
        },
        onClose()
        {
            this.showRecursosTxt = false;
        }
    },
    computed: {
        ...mapGetters(['waitCursor']),
        showRecursosTxt:
        {
            get()
            {
                return this.$store.getters.showRecursosTxt;
            },
            set(showRecursosTxt)
            {
                this.$store.dispatch('updateShowRecursosTxt', showRecursosTxt);
            }
        }
    }
};
</script>

<i18n>
{
    "es": {
        "title": "Recursos",
        "p1": "A continuación presentamos algunos ejemplos de nuestros reportes de diagnóstico. Si tiene interés pr algunos de ellos no dude en contactarnos.",
        "feedback360": "Retroalimentación 360°",
        "workTeams": "Equipos de trabajo",
        "emotionalIntelligence": "Inteligencia emocional",
        "p2": "Algunos artículos de interés sobre los temas de diagnóstico que hemos comentado aparecen al final de esta sección para que pueda bajarlos y leerlos cuando desee informarse sobre alguno de estos temas."
    },
    
    "en": {
        "title": "Resources",
        "p1": "A continuación presentamos algunos ejemplos de nuestros reportes de diagnóstico. Si tiene interés pr algunos de ellos no dude en contactarnos.",
        "feedback360": "Retroalimentación 360°",
        "workTeams": "Equipos de trabajo",
        "emotionalIntelligence": "Inteligencia emocional",
        "p2": "Algunos artículos de interés sobre los temas de diagnóstico que hemos comentado aparecen al final de esta sección para que pueda bajarlos y leerlos cuando desee informarse sobre alguno de estos temas."
    }
}
</i18n>

<style scoped>
.sub-window {
    /* background: rgba(0, 77, 64, 0.6); */
    background: rgba(26, 32, 38, 0.84);
}
</style>